module.exports = __webpack_public_path__ + "img/11825386_L.48f98abe.png";